<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload" />
    </div>

    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面談日期起</label>
              <el-date-picker
                style="width: 100%"
                v-model="search.InvitationStartTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="yyyy-mm-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面談日期迄</label>
              <el-date-picker
                style="width: 100%"
                v-model="search.InvitationEndTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="yyyy-mm-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">時段</label>
              <el-select
                style="display: block"
                v-model="search.TimePeriod"
                placeholder="請選擇"
              >
                <el-option label="全部" :value="null"> </el-option>
                <el-option label="上午" :value="1"> </el-option>
                <el-option label="下午" :value="2"> </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">應徵職務</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ManpowerDemandName"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">招募窗口</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ContactPerson"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">姓名</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.Name"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">是否異常</label>
              <el-select
                style="display: block"
                v-model="search.AnyWrong"
                placeholder="請選擇"
              >
                <el-option label="全部" :value="null"> </el-option>
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">是否回覆</label>
              <el-select
                style="display: block"
                v-model="search.Replied"
                placeholder="請選擇"
              >
                <el-option label="全部" :value="null"> </el-option>
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <button
              @click="getData"
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
            >
              {{ i18n("BUTTON.SEARCH") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="
                search = {
                  InvitationStartTime: search.InvitationStartTime,
                  InvitationEndTime: search.InvitationEndTime,
                }
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="text-right">
      {{ reloadTime }}
      <el-button type="primary" size="small" @click="openUploadModal()"
        >匯入問卷結果</el-button
      >
    </div>

    <el-tabs v-model="activeName" @tab-click="getData">
      <el-tab-pane label="IDL" name="IDL"> </el-tab-pane>
      <el-tab-pane label="DL" name="DL"> </el-tab-pane>
    </el-tabs>

    <div class="yahome-table-wrap">
      <el-table :data="rows" style="width: 100%">
        <el-table-column
          label="面試日期"
          prop="InvitationTime"
          :formatter="dateFormatter"
          sortable
        ></el-table-column>
        <el-table-column label="姓名" prop="Name" sortable></el-table-column>
        <el-table-column label="身分證字號/護照號碼" prop="IdNo" sortable></el-table-column>
        <el-table-column
          label="應徵職務"
          prop="ManpowerDemandName"
          sortable
        ></el-table-column>
        <el-table-column label="招募窗口" prop="ContactName" sortable></el-table-column>
        <el-table-column label="建議內容" sortable>
          <template slot-scope="props">
            <abbr class="dot-text" :title="props.row.AdviceContents">{{
              props.row.AdviceContents
            }}</abbr>
          </template>
        </el-table-column>
        <el-table-column label="檢視" width="100" align="center">
          <template slot-scope="props">
            <el-button
              v-if="!props.row.AnyWrong"
              size="small"
              type='primary'
              @click="showMoreDetail(props.row.Guid, props.row.Replied)"
            >
              檢視
            </el-button>

            <el-button
              v-else
              size="small"
              :type="props.row.Replied ? 'info' : 'danger'"
              @click="showMoreDetail(props.row.Guid, props.row.Replied)"
            >
              檢視
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Detail Modal -->
    <div
      class="modal fade"
      id="detailModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div ref="settingModal" class="modal-content">
          <div class="modal-header">面試意見回饋表</div>
          <div class="modal-body">
            <div style="display: flex; justify-content: space-between">
              <span>處理內容</span>
              <span>最後更新者:{{ replyModal.UpdateUser }}</span>
            </div>

            <el-input
              type="textarea"
              style="width: 100%"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="請輸入內容"
              v-model="replyModal.Contents"
            >
            </el-input>

            <br />
            <br />

            <table class="feedback-table">
              <tr>
                <th scope="row" rowspan="4">基本資料</th>
                <th scope="row">面試日期</th>
                <td>{{ detailModal.InvitationTime | moment }}</td>
              </tr>
              <tr>
                <th scope="row">姓名</th>
                <td>{{ detailModal.Name }}</td>
              </tr>
              <tr>
                <th scope="row">面試職位</th>
                <td>{{ detailModal.ManpowerDemandName }}</td>
              </tr>
              <tr>
                <th scope="row">邀約面試人員</th>
                <td>{{ detailModal.ContactName }}</td>
              </tr>

              <template v-for="(Categories, catrgaryIndex) in detailModal.Categories">
                <tr :key="Categories.Guid" v-if="Categories.Name">
                  <th scope="row" :rowspan="Categories.Questions.length + 1">
                    {{ Categories.Name }}
                  </th>
                </tr>
                <tr
                  v-for="(Questions, index) in Categories.Questions"
                  :key="Questions.Guid"
                  v-show="Categories.Name"
                >
                  <th scope="row">{{ Questions.Title }}</th>
                  <td>
                    <span v-if="Questions.Value === 'true'">是</span>
                    <span
                      :style="{
                        color: index === 0 && catrgaryIndex === 0 ? '#00000' : '#ff0000',
                      }"
                      v-if="Questions.Value === 'false'"
                    >
                      否
                    </span>
                  </td>
                </tr>

                <template v-for="Questions in Categories.Questions">
                  <tr :key="`${Questions.Guid}+q`" v-show="!Categories.Name">
                    <th scope="col" colspan="3">{{ Questions.Seq }}. {{ Questions.Title }}</th>
                  </tr>
                  <tr :key="`${Questions.Guid}+a`" v-show="!Categories.Name">
                    <td colspan="3">{{ Questions.Value }}</td>
                  </tr>
                </template>
              </template>
            </table>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              取消
            </button>
            <button
              type="reset"
              class="btn btn-primary"
              @click="saveReply()"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- 匯入資料-->
    <div class="modal fade" id="uploadModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <span>匯入資料</span>
          </div>
          <div class="modal-body" style="margin-bottom: 20px">
            <p class="form-group">
              <u style="color: midnightblue; cursor: pointer" @click="downloadTemplate">
                點擊下載範例檔
              </u>
            </p>
            <p class="form-group">
              <span class="mark">* 上傳前請確認是否符合格式</span><br />
            </p>
            <div class="from-group">
              <label for=""><span class="mark">*</span>檔案</label>
              <el-upload
                ref="upload"
                action
                accept=".xls,.xlsx"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="uploadFile"
                :limit="1"
              >
                <el-button size="small" type="primary">點擊上傳</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      reloadTime: null, //重新刷新的時間
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      search: {
        InvitationStartTime: this.dayjs().subtract(1, "month").format("YYYY-MM-DD"),
        InvitationEndTime: new Date(),
        ResumeType: null,
      },
      activeName: "IDL",
      rows: [],
      detailModal: {},
      replyModal: {},
    };
  },

  methods: {
    getData() {
      const vm = this;
      if (vm.activeName === "IDL") {
        vm.search.ResumeType = 1;
      } else {
        vm.search.ResumeType = 0;
      }
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getFeedbackResult(vm.search)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.rows = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    reload() {
      //重新讀取
      const today = new Date();
      const hour = today.getHours();
      const min = today.getMinutes();
      const sec = today.getSeconds();

      // 轉成字串，如果低於10，前面加上'0'
      const hourString = hour < 10 ? "0" + hour : "" + hour;
      const minString = min < 10 ? "0" + min : "" + min;
      const secString = sec < 10 ? "0" + sec : "" + sec;

      this.reloadTime = hourString + ":" + minString + ":" + secString;
      this.getData();
    },
    openReplyModal(id) {
      const vm = this;

      return new Promise((resolve, reject) => {
        vm.$api.InterviewSch.getFeedbackReply(id)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              resolve(response.data.Data);
            }
          })
          .catch((error) => {
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
            reject("失敗");
          });
      });
    },
    saveReply() {
      const vm = this;
      vm.$api.InterviewSch.saveFeedbackReply(
        {
          ...vm.replyModal,
          Contents : vm.replyModal.Contents? vm.replyModal.Contents:""
      })
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getData();
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
            $("#detailModal").modal("hide");
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    async showMoreDetail(id, Replied) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      
      vm.replyModal = await vm.openReplyModal(id);  
      vm.detailModal = await vm.openDetailModal(id);

      vm.detailModal = {
          Replied: Replied,
          ...vm.detailModal
        };

      

      vm.$store.dispatch("updateLoading", false);

      $("#detailModal").modal("show");
    },

    openDetailModal(id) {
      const vm = this;

      return new Promise((resolve, reject) => {
        vm.$api.InterviewSch.getFeedbackResultDetail(id)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              resolve(response.data.Data);
            }
          })
          .catch((error) => {
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });

            reject("失敗");
          });
      });
    },

    openUploadModal() {
      $("#uploadModal").modal("show");
    },

    // 下載 滿意度範例檔
    downloadTemplate() {
      this.$api.InterviewSch.feedbackTemplateDownload().then((response) => {
        if (response.status === 200) {
          let filename = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split("filename*=UTF-8''")[1]
            )
          );
          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },

    // 上傳 滿意度
    uploadFile(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$notify({
          title: "失敗",
          message: "檔案大小不得超過10MB",
          type: "error",
          duration: 0,
        });
        return false;
      }

      let fd = new FormData();
      fd.append("File", file.raw);

      $("#uploadModal").modal("hide");

      this.$store.dispatch("updateLoading", true);
      this.$api.InterviewSch.uploadFeedback(fd)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
            this.getData();
          }

          this.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          this.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
      this.$refs.upload.clearFiles();
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    dateFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.feedback-table {
  width: 100%;
  margin-bottom: -1px;
  font-size: 0.9em;
  th {
    background-color: #f1f1f1;
    font-weight: normal;
  }
  th,
  td {
    border: 1px solid #ccc;
    padding: 5px;
  }
}

.dot-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>
